import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-municipality-onboarding-confirm-cancel-modal',
  templateUrl: './municipality-onboarding-confirm-cancel-modal.component.html',
  styleUrls: ['./municipality-onboarding-confirm-cancel-modal.component.scss'],
})
export class MunicipalityOnboardingConfirmCancelModalComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<MunicipalityOnboardingConfirmCancelModalComponent>,
    public translate: TranslateService,
  ) {}

  /**
   * closes dialog with dialogResult false
   */
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  /**
   * closes dialog with dialogResult true
   */
  onConfirmCancelClick(): void {
    this.dialogRef.close(true);
  }
}
